import { isEmpty } from 'lodash-es';
export default class Tour {
  static init() {
    return new Tour();
  }

  constructor() {
    let metaTour = document.querySelector('meta[name="tour"]');
    !!metaTour && this.show(metaTour.content);
  }

  show(key) {
    if (typeof Conpass === 'undefined' || isEmpty(key))
      return;

    Conpass.startFlow(key);
  }
};